module.exports = __webpack_public_path__ + "static/media/yom_logo_large.df8e05a0.png";